import { SettingsPageState } from '../state';
import { useSelector } from '../useSelector';
import { FieldValues } from 'react-hook-form';

export function useSettings<T, V extends FieldValues = FieldValues>(
  state: SettingsPageState<T, V>,
) {
  return useSelector(() => state.settings);
}
